import { graphql, Link, useStaticQuery } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useState } from "react"
import { Container } from "react-bootstrap"
import "../../styles/component/hello-bar.scss"
import SVGIcon from "../common/SVGIcon"
import { checkIndAndAbroadTime, slugChecker } from "../common/util-functions"

const HelloBar = props => {
  const data1 = useHelloBarQuery()
  const data = data1.one.pages
  const [userCountryCode, setUserCountryCode] = useState()
  const [helloBarData, setHelloBarData] = useState(null)

  useEffect(() => {
    async function fetchIPCountryCode() {
      try {
        const res = await fetch(process.env.IP_STACK_API)
        const data = await res.json()
        if (data && data.country_code) {
          setUserCountryCode(data?.country_code)
        } else {
          console.warn("country_code is missing in IPStack response:", data)
        }
      } catch (error) {
        console.error("Failed to fetch IPStack data:", error)
      }
    }

    fetchIPCountryCode()
  }, [])
  const hellobars = data[0]?.helloBar || []

  useEffect(() => {
    if (!userCountryCode || !hellobars.length) return

    const getHellobarData = (hellobars, userCountryCode) => {
      const matched = hellobars.find(bar => bar.countryCode === userCountryCode)
      if (matched) return matched

      const defaultBar = hellobars.find(bar => bar.countryCode === "default")
      return defaultBar || {} // return empty object if no default
    }

    const result = getHellobarData(hellobars, userCountryCode)
    setHelloBarData(result)
  }, [userCountryCode])

  useEffect(() => {
    if (!userCountryCode || !helloBarData || !data.length) return

    const eventTimeIndia = helloBarData.eventTime
    const helloBarView = helloBarData.helloBarView === "block" ? false : true

    if (
      helloBarData &&
      Object.keys(helloBarData).length > 0 &&
      hellobars.length > 0 &&
      (eventTimeIndia ? checkIndAndAbroadTime(eventTimeIndia) : true) &&
      slugChecker(data[0].showHellobar, data[0].pageSlugs) &&
      helloBarView
    ) {
      props.isHelloBarVisible(true)
    }
  }, [helloBarData, data])
  return (
    <>
      {helloBarData && Object.keys(helloBarData).length > 0 && (
        <div className={`hello-bar ${props.className}`} style={props.style}>
          <Container className="Layout-container-big prelative h-100">
            <Link
              to={helloBarData.slug}
            >
              <div className="alert-info-wrapper">
                <div className="side-heading">
                  <div className="webinar-group align-items-center">
                    <SVGIcon name="webinar-bell" className="alert-bell" />
                    {parse(helloBarData.pageBlock[0].blockContent.html)}
                  </div>
                  <SVGIcon
                    name="close-icon-black"
                    className="closeBtn mobile"
                    onClick={e => {
                      e.stopPropagation()
                      e.preventDefault()
                      props.isHelloBarVisible(false)
                    }}
                  />
                </div>
                <div className="center-content">
                  <p className="main-content">
                    {parse(helloBarData.pageBlock[1].blockContent.html)}
                  </p>
                  {helloBarData.pageBlock[2].blockContent.text && (
                    <Link
                      className="d-inline-flex align-items-center link"
                      to={helloBarData.slug}
                    >
                      {parse(helloBarData.pageBlock[2].blockContent.html)}
                      <SVGIcon
                        name="hypertext-arrow-right"
                        className="arrow-right"
                      />
                    </Link>
                  )}
                </div>
                <SVGIcon
                  name="close-icon-black"
                  className="closeBtn desktop"
                  onClick={e => {
                    e.stopPropagation()
                    e.preventDefault()
                    props.isHelloBarVisible(false)
                  }}
                />
              </div>
            </Link>
          </Container>
        </div>
      )}
    </>
  )
}

export default HelloBar

export function useHelloBarQuery() {
  const returneddata = useStaticQuery(graphql`
    query helloBarContent {
      one: SuperOps {
        pages(where: { title: "Hello bar one" }) {
          pageBlock {
            id
            content {
              html
              text
            }
          }
          slug
          linkTitle
          eventTime
          showHellobar
          pageSlugs
          helloBar {
            ... on SuperOps_HelloBarComponent {
              countryCode
              eventTime
              slug
              pageBlock {
                ... on SuperOps_Block {
                  blockContent {
                    html
                    text
                  }
                }
              }
              helloBarView
            }
          }
        }
      }
      two: SuperOps {
        pages(where: { title: "Hello bar two" }) {
          pageBlock {
            id
            content {
              html
              text
            }
          }
          slug
          linkTitle
          eventTime
          showHellobar
          pageSlugs
        }
      }
    }
  `)
  return returneddata
}
